import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    ButtonSecondary,
    CollapsiblePanel,
    CollapsiblePanelBody,
    CollapsiblePanelHeader,
    HorizontalFlex,
    PadContainer,
} from 'smartsuite-ui';
import CustomizableTable from '../../../../viewDashboards/widgets/customizableTable/CustomizableTable';
import useLink from '../../../../shared/hooks/linkHooks';

export default function InboundFlightTable(props) {
    const [isCollapsed, setIsCollapsed] = useState(props.defaultCollapsed);

    const linkUri = useLink(
        props.configuration.linkConfig,
        props.headerRequest,
        props.headerData
    );

    return (
        <CollapsiblePanel
            isCollapsed={isCollapsed}
            onCollapse={() => setIsCollapsed(!isCollapsed)}
        >
            <CollapsiblePanelHeader
                autoHideRollupText={false}
                headerLabel={<div>{props.headerData.arrivalStation}</div>}
            >
                <HorizontalFlex
                    cssClassModifiers={['justify-flex-end', 'flex-wrap']}
                >
                    <HorizontalFlex>
                        {`${props.customLabels['key:actioned']}:`}
                        <PadContainer cssClassModifiers={['pad-small']} />
                        <span className="flight-tables__header-item">
                            {props.headerData.actionedBags}/
                            {props.headerData.problemBags}
                        </span>
                        <PadContainer />
                    </HorizontalFlex>
                    <ButtonSecondary
                        onClick={() => {
                            window.open(linkUri);
                        }}
                    >
                        {props.customLabels['key:viewStation']}
                    </ButtonSecondary>
                </HorizontalFlex>
            </CollapsiblePanelHeader>
            <CollapsiblePanelBody>
                <CustomizableTable
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...props}
                    data={props.tableData}
                    formatValue={props.formatter}
                    metricRequest={props.tableRequest}
                />
            </CollapsiblePanelBody>
        </CollapsiblePanel>
    );
}

InboundFlightTable.propTypes = {
    defaultCollapsed: PropTypes.bool.isRequired,
    formatter: PropTypes.func.isRequired,
    headerData: PropTypes.instanceOf(Object).isRequired,
    headerRequest: PropTypes.instanceOf(Object).isRequired,
    configuration: PropTypes.instanceOf(Object).isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    tableData: PropTypes.instanceOf(Array).isRequired,
    tableRequest: PropTypes.instanceOf(Object).isRequired,
    customLabels: PropTypes.instanceOf(Object).isRequired,
};
